import { NEW_RELIC_HEADERS } from '@/lib/newrelic/newRelicContext'
import { onError } from '@apollo/client/link/error'

/**
 * Apollo link middleware that handles network errors.
 * This link logs network errors to the console.
 *
 * @returns {ApolloLink} An Apollo link that intercepts network errors
 */
export const makeErrorLink = () =>
  onError(({ graphQLErrors, networkError, operation }) => {
    if (graphQLErrors) {
      graphQLErrors.forEach(({ message, locations, path }) => {
        console.error(
          `🔴 [GraphQL error]: Message: ${message}, Location: ${JSON.stringify(locations)}, Path: ${path}`,
          { traceId: operation.getContext()?.headers?.[NEW_RELIC_HEADERS.traceId] },
        )
      })
    }

    if (networkError) {
      if (/ETIMEDOUT/i.test(`${networkError.cause}${networkError.message}${networkError}`))
        console.error(`🔴 [TIMEOUT]: Operation "${operation?.operationName}" timed out.`)
      else if (networkError?.cause) {
        const queryVariables = operation.variables
          ? ' - ' + JSON.stringify(operation.variables)
          : ''

        console.error(
          `🔴 [NETWORK]: cause: ${networkError.cause}
message: ${networkError.message}
Operation "${operation.operationName}"${queryVariables}`,
          { traceId: operation.getContext()?.headers?.[NEW_RELIC_HEADERS.traceId] },
        )
      }

      // eslint-disable-next-line no-console
      console.debug(operation.query)
    }
  })
